<template>
  <div class="page" id="loginPage">
    <div class="login-logo"></div>
    <div class="login-wrap">
      <el-form :model="ruleForm" ref="ruleForm" class="login-container">
        <div class="fl title">
          Log into Linkplus</div>
        <div class="tip-title ft-16">For security reasons, please change your initial password when you log in the first time.</div>
        <div class="subtitle">
          <div class="password ft-16">New Password</div>
        </div>
        <el-form-item prop="password" style="margin-top: 10px">
          <el-input class="login-input" type="password" v-model="ruleForm.password" auto-complete="off" placeholder="
Enter your new password">
          </el-input>
        </el-form-item>
        <el-form-item style="width: 100%; margin-top: 20px">
          <el-button type="primary" class="login-button" @click="hadnleSubmit()">Submit</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
 
<script>
import { post } from "@/script/api.js";
import { JSEncrypt } from 'jsencrypt'

export default {
  components: {},
  props: {
    // isAdminLogin:Boolean,
  },
  data() {
    return {
      isEncrypted: true,
      ruleForm: {
        username: null,
        password: null,
        verificationCode: null,
      },

    };
  },

  mounted() {
  },

  methods: {
    hadnleSubmit() {
      if (!this.ruleForm.password) {
        this.$message.error("Please enter your new password");
        return false;
      }
      const reg = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
      if (!reg.test(this.ruleForm.password)) {
        this.$message.error("Please enter at least eight characters and at least one digit, one special character, one uppercase letter, and one lowercase letter.");
        return false;
      }
      // 创建 RSA 加密实例
      var encrypt = new JSEncrypt();
      // 设置 RSA 公钥
      var publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCEYgFPf+RXFR9WExDBEeFSbOXnOg9R6zUvz/dDP0dY0emP/xrFS+t5bs0XGi1joRZ30sMbPWWyfAbKPziWaZ+VYuNOsDEyFF2CFZskZi3r3lYicnTns0zGhdtrXb3X+uDNavR1Fik8VnwByo8oWmW+4y5jU5k8AbAWmPlPzCPS4QIDAQAB';
      encrypt.setPublicKey(publicKey);
      // 要加密的数据
      var plaintext = this.ruleForm.password;
      // 进行 RSA 加密
      var encrypted = encrypt.encrypt(plaintext);
      post("modifyPassword  ", {
        userId: localStorage.getItem('userId'),
        newPassword: encrypted
      }).then((res) => {
        console.log("首次修改密码结果", res);
        if (res.code == 0) {
          console.log("首次修改密码成功", res);
          localStorage.setItem("accessToken", res.data.accessToken); //缓存拿到的token值
          localStorage.setItem("refreshToken", res.data.refreshToken);
          localStorage.setItem("email", res.data.email);
          localStorage.setItem('userId', res.data.userId);
          this.$router.replace('/mainView');
        } else {
          this.$message.error(res.msg);
          // localStorage.clear();
        }
      });
    },
  },
};
</script>

<style scoped>
#loginPage {
  background: url("../assets/images/login-bg.jpg") no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-style: normal;
  font-weight: 400;
  height: 100vh;
}

.login-logo {
  background: url("../assets/images/logo.png") no-repeat;
  width: 309px;
  height: 46px;
}

.login-container {
  border-radius: 15px;
  margin: 40px auto 0 auto;
  width: 580px;
  padding: 50px 65px 0 65px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}

.title {
  margin: 0px auto auto auto;
  color: black;
  font-weight: 700;
  font-style: normal;
  font-size: 22px;
}

.tip-title {
  margin-top: 35px;
  color: #D9001B;
  text-align: left;
}

.subtitle {
  margin-top: 30px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.login-input>>>.el-input__inner {
  height: 50px;
  border: 1px solid lightgray;
  width: 100%;
  border-radius: 6px;
  padding-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}

.login-button {
  width: 100%;
  height: 50px;
  margin-top: 40px;
  margin-bottom: 70px;
  background-color: rgb(148, 200, 66);
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/ResetInitialPassword.vue